export enum GamesCount {
  MOBILE = 5,
  DESKTOP = 9,
}
